import projectAddressEditComponent from './project-address-edit.component';

const projectAddressEditModule = angular.module('projectAddressEdit', [
])
  .component('projectAddressEdit', projectAddressEditComponent)
  .name;

export default projectAddressEditModule;
